import React from "react";
import { Col } from "reactstrap";
import { dynamicImage, Image } from "../../../Utils";

const BgImage = () => {
  return (
    <Col xs="12" lg="6" className="px-0">
      <div className="login-bg-img">
        <Image className="bg-img-cover bg-center img-fluid for-light" src={dynamicImage("login_signup/01.png")} alt="login-bg-img" />
        <Image className="bg-img-cover bg-center img-fluid for-dark" src={dynamicImage("login_signup/02.png")} alt="login-bg-img" />
      </div>
    </Col>
  );
};

export default BgImage;
